import { ReactNode } from 'react'
import i18n from '@signavio/i18n'

import { LegacyHint, PlaceholderTile, TextTile } from '@signavio/ui'

import { useApi } from '../../api'
import types from '../../apiTypes'

import GroupTile from './GroupTile'

type GroupProps = {
  value: string
  circular?: boolean
  transparent?: boolean
  toolbar?: ReactNode
}

function Group({ value, ...rest }: GroupProps) {
  const [fetchGroup] = useApi(types.GROUP, { id: value })

  if (fetchGroup.rejected) {
    return (
      <TextTile {...rest}>
        <LegacyHint danger inline>
          {i18n('Failed to load group.')}
        </LegacyHint>
      </TextTile>
    )
  }

  if (fetchGroup.pending || !fetchGroup.value) {
    return <PlaceholderTile withHeader {...rest} />
  }

  return <GroupTile group={fetchGroup.value} {...rest} />
}

export default Group
